import * as React from 'react'
import './style.scss'

type Props = {
  className?: string
  id?: string
  children?: React.ReactNode[] | React.ReactNode
}

class Container extends React.Component<Props> {
  render() {
    const { className = '', children, id } = this.props

    return (
      <section
        className={`${className} cf-container`}
        id={id}
      >
        {children}
      </section>
    )
  }
}

export default Container
